import {Injectable} from '@angular/core';
import {INotificacao} from '@interfaces/notificacao';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificacoesService {

  static readonly localStorageKey = 'notificacoes-list'
  items$ = new BehaviorSubject<Array<INotificacao>>([])
  intervals = {}

  constructor() {
    this.loadItemsFromLocalStorage()
    this.watchItemsChange()
  }

  loadItemsFromLocalStorage() {
    const itemsStr = localStorage.getItem(NotificacoesService.localStorageKey);
    if (!itemsStr) {
      return
    }
    const items: Array<INotificacao> = JSON.parse(itemsStr)
    this.items$.next(items)
  }

  watchItemsChange() {
    this.items$.subscribe(items => {
      items.forEach(notificacao => {
        if (notificacao.interval?.fn && !this.intervals[notificacao.id]) {
          this.configurarInterval(notificacao)
        }
      });
      localStorage.setItem(NotificacoesService.localStorageKey, JSON.stringify(items.map(notificacao => {
        if (notificacao.interval) {
          delete notificacao.interval
        }
        return notificacao
      })))
    })
  }

  adicionar(notificacao: INotificacao): string {
    if (!notificacao.id) {
      notificacao.id = 'notificacao-' + new Date().toISOString()
    }
    this.items$.next([
      notificacao,
      ...this.items$.value,
    ])
    if (notificacao.timeout) {
      setTimeout(() => {
        this.remover(notificacao.id)
      }, notificacao.timeout);
    }
    return notificacao.id
  }

  remover(notificacaoId: string) {
    const items = this.items$.value.filter(item => item.id !== notificacaoId)
    this.items$.next(items)
  }

  atualizar(notificacao: INotificacao): INotificacao {
    const items = this.items$.value;
    const old = items.find(item => item.id === notificacao.id)
    const updatedItem = Object.assign(old, notificacao)
    this.items$.next(items)
    return updatedItem
  }

  limpar() {
    this.items$.next([])
  }

  configurarInterval(notificacao: INotificacao) {
    this.intervals[notificacao.id] = setInterval(
      notificacao.interval.fn.bind(this, notificacao),
      notificacao.interval.ms,
    )
  }

  clearInterval(notificacao: INotificacao) {
    clearInterval(this.intervals[notificacao.id])
    delete this.intervals[notificacao.id]
  }
}
